import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { NgClass } from '@angular/common'

interface GrupoOption {
  itemPropostaId: number
  tipoVeiculoDescricao: string
  capacidade: number
  data: string
  horaInicio: string
  horaFinal: string
  voo: string | null
  passageiros: any[]
}

@Component({
  selector: 'modal-mover-passageiro',
  standalone: true,
  imports: [FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, NgClass],
  template: `
    <div class="mover-dialog">
      <div class="mover-header">
        <span class="mover-title">Mover passageiro</span>
        <span class="mover-sub">{{ data.passageiro.nome }}</span>
      </div>

      <div class="mover-grupos">
        @for (grupo of data.grupos; track $index) {
          <div class="grupo-option"
               [ngClass]="{ 'option-selected': selectedGroup === grupo }"
               (click)="selectedGroup = grupo">
            <div class="radio-dot" [ngClass]="{ 'radio-checked': selectedGroup === grupo }"></div>
            <div class="option-info">
              <span class="option-veiculo">{{ grupo.tipoVeiculoDescricao }}</span>
              <span class="option-detalhe">
                {{ grupo.data }} &bull; {{ grupo.horaInicio }} – {{ grupo.horaFinal }}
                @if (grupo.voo) { &bull; {{ grupo.voo }} }
              </span>
            </div>
            <span class="option-pax" [ngClass]="{ 'pax-full': grupo.passageiros.length >= grupo.capacidade }">
              {{ grupo.passageiros.length }} / {{ grupo.capacidade }} PAX
            </span>
          </div>
        }

        @if (data.grupos.length === 0) {
          <div class="no-grupos">Nenhum outro grupo disponível.</div>
        }
      </div>

      <div class="mover-actions">
        <button mat-button class="btn-tg-white" (click)="cancelar()">Cancelar</button>
        <button mat-button class="btn-tg" [disabled]="!selectedGroup" (click)="confirmar()">Mover</button>
      </div>
    </div>
  `,
  styles: [`
    .mover-dialog {
      display: flex;
      flex-direction: column;
      width: 460px;
      max-height: 70vh;
    }
    .mover-header {
      padding: 20px 24px 14px;
      border-bottom: 1px solid #e5e7eb;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .mover-title {
      font-size: 16px;
      font-weight: 600;
      color: #1f2937;
    }
    .mover-sub {
      font-size: 13px;
      color: #6b7280;
    }
    .mover-grupos {
      flex: 1;
      overflow-y: auto;
      padding: 12px 16px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .grupo-option {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 12px 14px;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      cursor: pointer;
      transition: background 0.15s, border-color 0.15s;
      background: #fff;
    }
    .grupo-option:hover {
      background: #f9fafb;
    }
    .option-selected {
      border-color: #ea6218 !important;
      background: #f3d3c1 !important;
    }
    .radio-dot {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 2px solid #d1d5db;
      flex-shrink: 0;
      transition: border-color 0.15s;
    }
    .radio-checked {
      border-color: #ea6218;
      background: radial-gradient(circle, #ea6218 40%, transparent 41%);
    }
    .option-info {
      display: flex;
      flex-direction: column;
      gap: 2px;
      flex: 1;
      min-width: 0;
    }
    .option-veiculo {
      font-size: 13px;
      font-weight: 600;
      color: #1f2937;
    }
    .option-detalhe {
      font-size: 11px;
      color: #6b7280;
    }
    .option-pax {
      font-size: 11px;
      font-weight: 600;
      background: #f3d3c1;
      color: #9b4716;
      border-radius: 12px;
      padding: 2px 10px;
      white-space: nowrap;
      flex-shrink: 0;
    }
    .pax-full {
      background: rgba(176, 1, 1, 0.12);
      color: #b00101;
    }
    .no-grupos {
      font-size: 13px;
      color: #9ca3af;
      text-align: center;
      padding: 24px 0;
    }
    .mover-actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      padding: 12px 16px;
      border-top: 1px solid #e5e7eb;
    }
  `],
})
export class ModalMoverPassageiroComponent {
  selectedGroup: GrupoOption | null = null

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { passageiro: any; grupos: GrupoOption[] },
    private dialogRef: MatDialogRef<ModalMoverPassageiroComponent>,
  ) {}

  confirmar() {
    this.dialogRef.close(this.selectedGroup)
  }

  cancelar() {
    this.dialogRef.close(null)
  }
}
